import { loadGraphFontsFromUrl } from '@ipfabric/utils';

export const loadGraphFonts = (): Promise<void> =>
  loadGraphFontsFromUrl('/public/fonts');
